<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
<div class="mb-2 mt-2">
  <h4  class="mb-2 py-1 font-header-1">Transactions Menu </h4>
</div>
  <div class="col ps-0">
    <div class="card">

      <div class="card-body  widget-body pt-2">
        
                  <div class="row mt-2">
                      <div class="col-lg-5">
                          <div class="row">
                              <div class="col-lg-4  ">
                                  <span>Start date</span>
                              </div>

                              <div class="col-lg-8 col-11  ">
                                  <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                      [selDate]="FromDateFilter"
                                      (inputFieldChanged)="newdates($event,'inputchage','FilterFromDate')"
                                      (dateChanged)="newdates($event,'datechagned','FilterFromDate')">
                                  </my-date-picker>
                              </div>
                          </div>
                      </div>
                      <div class="col-lg-5">
                          <div class="row">
                              <div class="col-lg-4  ">
                                  <span>End date</span>
                              </div>
                              <div class="col-lg-8 col-11 ">
                                  <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                      [selDate]="EndDateFilter"
                                      (inputFieldChanged)="newdates($event,'inputchage','FilterToDate')"
                                      (dateChanged)="newdates($event,'datechagned','FilterToDate')">
                                  </my-date-picker>
                              </div>
                          </div>
                      </div>
                     
                  </div>
                  <!-- CLient & employee  -->
                  <div class="row mt-2">
                      <div class="col-lg-5">
                        <div class="row">
                          <div class="col-lg-4 ">
                              <span>Client</span>
                          </div>
                          <div class="col-lg-8 col-11 ">
                              <ng-select [searchable]="true" [(ngModel)]="getTransactions.clientId" [clearable]="true"
                                  bindLabel="Value" bindValue="Key" [items]="AllClientDropDownList">
                              </ng-select>
                          </div>
                      </div>
                      </div>
                      <div class="col-lg-5">
                         
                          <div class="row">
                            <div class="col-lg-4">
                                <span>Service</span>
                            </div>
                            <div class="col-lg-8 col-11 ">
                              <ng-select [(ngModel)]="getTransactions.serviceId" [searchable]="true" [clearable]="true"
                                [items]="serviceList" bindLabel="Value" bindValue="Key" groupBy="type">
                              </ng-select>
                            </div>
                        </div>
                      </div>
                      <div class="col-lg-2 text-end">
                        <div>
                          <button type="button" class="btn btn-sm me-3" (click)="exportCsv()">
                            <i class="fa fa-file-excel-o "></i>Export</button>
                            <button type="button" class="btn btn-sm" (click)="ApplyFilter()">Apply
                            </button>
                            <button type="button" class="btn btn-sm ml-1" (click)="refresh()"
                            style="margin-left: 11px;">Refresh
                        </button>
                        </div>
                    </div>
                     

                  </div>
                  <div class="row mt-2 mb-2">
                    <div class="col-lg-8">
                      <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal"
                (click)="CreateorUpdateList('new')"   *ngIf="fp.transactioncreate">
                Add New Transaction
              </button>
                    </div>
                  </div>
                 
                
</div>
      

            

    </div>

  </div>

</div>


<div  class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="col ps-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body  widget-body pt-2">
        <ejs-grid #grid [dataSource]='gridTransactions | async' [allowPaging]='true' [pageSettings]='initialPage'
         [filterSettings]='filterSettings' [allowSorting]='true'
           [allowFiltering]='true' [allowResizing]='true'
          (dataStateChange)='dataChangeTransactions($event)' [showColumnChooser]='true'
          (actionBegin)="onActionTransactions($event);" >
          <e-columns>
            <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center" [showInColumnChooser]='false'>
              <ng-template #template let-data>
                <button class="btn btn-edit-table" data-bs-target="#exampleModal" data-bs-toggle="modal" *ngIf="fp.transactionupdate"
                  (click)="selectTransactiondetails(data);CreateorUpdateList('edit')"  [disabled]="data.timesheetId!=null"><i
                    class="fa fa-edit" ></i></button>&nbsp;
                <button class="btn btn-delete-table" data-bs-target="#deletemodal" data-bs-toggle="modal"
                  (click)="getDetails(data)"  *ngIf="fp.transactiondelete"  [disabled]="data.timesheetId!=null"><i class="fa fa-trash"></i></button>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="transactionDate" [format]='formatOptions' headerText="Transaction Date"
            type="date">
            <ng-template #filterTemplate let-data>
              <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
            </ng-template>
          </e-column>
            <e-column minWidth=100 field="client" headerText="Client Name" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="payor" headerText="Payor Name" type="string" [allowFiltering]='false'
              [allowSorting]='false'>
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
            <e-column minWidth=100 field="serviceCode" headerText="Service Code" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
         
            <e-column minWidth=100 field="totalAmount" headerText="Amount" type="string">
              <ng-template #filterTemplate let-data>
                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
              </ng-template>
            </e-column>
           




            <e-column width="50" [showInColumnChooser]='false'>
              <ng-template #headerTemplate let-data>
                <div>
                  <span id='show' (click)='showTransactionColumns()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                    </i></span>
                </div>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<!-- Modal -->
<span id="exampleModalSave" data-bs-toggle="modal" data-bs-target="#exampleModal"></span>
<div class="modal fade modalbackgrod" id="exampleModal" data-bs-backdrop="false" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel"><span *ngIf="modalType=='new'"><b> Save
              Transaction</b></span> <span *ngIf="modalType=='edit'"><b>Update Transaction</b></span></h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="cancelValidation();" aria-label="Close"></button>
        
      </div>
      <div class="modal-body">
        <form [formGroup]="transactionForm">
          <div class="row">
            <div class="col-5">
              <div class="row">
                <div class="col-lg-3">
                  <span>Client <sup class="super-script">*</sup></span>
                </div>
                <div class="col-lg-8">
                  <ng-select class="w-100" style="color: black;" [clearable]="true" [searchable]="true" (ngModelChange)="clearFields()"
                    formControlName="client" [(ngModel)]="saveTransAction.clientId" [items]="ClientDropdown"
                    bindLabel="Value" bindValue="Key">
                  </ng-select>
                </div>
                <div class="col-lg-3 mt-2">
                  <span>Transaction Date <sup class="super-script">*</sup></span>
                </div>

                <div class="col-lg-8  mt-1">
                  <my-date-picker [options]="myDatePickerOptions"
                    placeholder="mm/dd/yyyy" formControlName="transactionDate"
                    [selDate]="saveTransAction.transactionDate"
                    (inputFieldChanged)="newdates($event,'inputchage','importdate')"
                    (dateChanged)="newdates($event,'datechagned','importdate');getAuthorizationTable()">
                  </my-date-picker>
                </div>
                <div class="col-lg-3  mt-2">
                  Payer <sup class="super-script">*</sup>
                </div>
                <div class="col-lg-8  mt-1">
                  <input type="text" [(ngModel)]="saveTransAction.payor" formControlName="payor" class="form-control" >
                </div>
                <div class="col-lg-3  mt-2">
                  <span> Service Code <sup class="super-script">*</sup></span>
                </div>
                <div class="col-lg-8  mt-1">
                  <input type="text" class="form-control" formControlName="serviceCode"
                    [(ngModel)]="saveTransAction.serviceCode" >
                </div>

                <div class="col-lg-3  mt-2">
                  <span> Amount <sup class="super-script">*</sup></span>
                </div>
                <div class="col-lg-8  mt-1">
                  <input  class="form-control" type="number" min="0" formControlName="totalAmount" [(ngModel)]="saveTransAction.totalAmount"
                    >
                </div>



              </div>

            </div>
            <div class="col-7"  *ngIf="showTable">
              <div class="row"  style="overflow-x: auto;">
                <div class="col">
                  <h3 class="para"> Authorization Details</h3>
                  <table class="table  table-bordered table-responsive" >
                    <thead>
                      <tr>
                        <th class="tab_head" scope="col">Start Date</th>
                        <th class="tab_head" scope="col">End Date</th>

                        <th class="tab_head" scope="col">Payor Name</th>
                        <th class="tab_head" scope="col">Service Code</th>

                        <th class="tab_head" scope="col">Auth Note</th>
                        <th class="tab_head" scope="col">Remaining Amount</th>
                        <th class="tab_head" scope="col">Insurance Number</th>


                        <!-- <th class="tab_head" scope="col">Total Amount</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let t of TranscaData">
                        <td>{{t.startDate  |date:'MM/dd/yyyy'}} </td>
                        <td>{{t.endDate |date:'MM/dd/yyyy' }}</td>

                        <td (click)="getauthoraization(t)"> {{t.payorName }} </td>
                        <td (click)="getauthoraization(t)"> {{t.serviceCode}} </td>
                        <td>{{t.authNote}} </td>
                        <td>{{t.remainingAmount}} </td>
                        <td>{{t.insuranceNumber}}</td>
                        <!-- <td>{{t.totalAmount}}</td> -->

                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
           
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm"  [disabled]="transactionForm.invalid"
          (click)="ExceddAmoutCheck()"><span *ngIf="modalType=='new'"> Save</span> <span
            *ngIf="modalType=='edit'">Update & Close</span></button>
      </div>

    </div>
  </div>
</div>


<!-- Button trigger modal -->

<span id="closeLovModal" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="deletemodal" data-bs-backdrop="false" data-bs-keyboard="false">
  <div class="modal-dialog " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Record</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>

      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this record ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm"  (click)="deleteTransaction()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm"  data-bs-dismiss="modal" >No</button>
      </div>
    </div>
  </div>
</div>


<!-------------  saveModal   -->
<!-- Button trigger modal -->


<!-- Modal -->
<span id="MinimumAmount" data-bs-target="#checkExceedAmount" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="checkExceedAmount" data-bs-backdrop="false" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="newSavLabel">Insufficient Balance!</h1>
        <button type="button" class="btn-close" (click)="cancelValidation()" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="text-center text-danger">
          <label class="font-red"><i class="fa fa-info-circle"></i>&nbsp;Entered Amount will exceed the remaining budget
            amount.
            Are you sure you want to save? </label>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button"  class="btn  btn-sm me-1" data-bs-dismiss="modal" (click)="saveOrUpdateTransaction()" class="btn btn-sm">Yes</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
        (click)="cancelValidation()">No</button>
      </div>
    </div>
  </div>
</div>



 
   
